import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const fields = block?.fields
  if (!fields) {
    return true
  }

  const hasHtmlContent = fields?.html && fields.html.replace('<p></p>', '').trim()

  if (!hasHtmlContent && !fields.css) {
    return true
  }

  return false
}
